import api from "./axios"; // this is your axios instance
import log from "../utils/log";

export async function fileUpload(file) {
    try {
        // ✅ Step 1: Get pre-signed URL using Axios (your backend API)
        const response = await api.post("/api/v2/upload", {
            contentType: file.type,
        });

        const { url, headers, key } = response.data;

        // ✅ Step 2: Upload file directly to S3 using Fetch
        const uploadRes = await fetch(url, {
            method: "PUT",
            headers,
            body: file,
            withCredentials: false,
        });

        if (!uploadRes.ok) {
            throw new Error("Failed to upload file to S3");
        }

        return response.data;
    } catch (error) {
        log.error("❌ Upload failed:", error);
        throw error;
    }
}
